package com.happyukrainian.revision.kweb.components

import androidx.compose.runtime.Composable
import com.happyukrainian.revision.kweb.config.HUColors
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.BoxScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.widthIn
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.document
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw

@Composable
fun PageContainer(modifier: Modifier = Modifier, content: @Composable BoxScope.(compact: Boolean) -> Unit) {
    val breakpoint = rememberBreakpoint()
    val compact = breakpoint < Breakpoint.MD
    val containerWidth = if (compact) 90 else 70

    Box(modifier.fillMaxSize().background(HUColors.background), contentAlignment = Alignment.Center) {
        Box(modifier = Modifier
            .width(min(containerWidth.vw, containerWidth.vh)),
            content = { content(compact) }
        )
    }
}